<template>
  <div class="NotFoundView">
    <div class="NotFoundView__content">
      <div class="NotFoundView__info">
        <SvgImage
        imageName="NotFound"
        class="NotFoundView__image"/>
        <span class="NotFoundView__title">
          The page you're attempting to view is no available.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>

<style lang="scss">
@import 'NotFoundView';
</style>
